import React, { type JSX } from 'react';
import { BodyContainerComponentsMapping } from '../../../../components/BodyContainerComponentsMapping';
import { BodyObject } from '../../../../types/api';
import { Box } from '../../../../wag-react/next-components/box';
type Props = {
  body: Array<BodyObject>;
};
export const DailyWagArticleBodyContainer = ({
  body
}: Props): JSX.Element => <Box data-sentry-element="Box" data-sentry-component="DailyWagArticleBodyContainer" data-sentry-source-file="index.tsx">
    {body.map((item, i) => <BodyContainerComponentsMapping key={String(item.type + i)} item={item} />)}
  </Box>;